export default __webpack_public_path__ + "static/us-map-mid-atlantic-73b842c7f0e14a4e19feae63b7780cf5.svg";